import {
  connect
} from 'react-redux'
import TagsInfoView from '../../components/TagsInfo/Index'

import {
  getTagsTotal,
  getClientTree,
  tagsSearch,
  tagsAllSearch
} from '../../actions/TagInfo'

const mapStateToProps = (state) => {
  const {
    tags_total,
    tags_tree,
    search_results,
    all_search_results
  } = state.tagsInfo;
  // let arr = [];
  // if (Array.isArray(state.app.clients)) {
  //   for (const list of state.app.clients) {
  //     let item = Object.assign({}, {
  //       label: list.name,
  //       value: list.id
  //     });
  //     arr.push(item);
  //   }
  // }
  return {
    tags_total,
    tags_tree,
    search_results,
    all_search_results,
    clients: state.app.clients,
    clientId: state.app.loginUserDetail && state.app.loginUserDetail.client.id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getTagsTotal: () => {
      dispatch(getTagsTotal());
    },
    getClientTree: (obj) => {
      dispatch(getClientTree(obj))
    },
    tagsSearch: (obj) => {
      dispatch(tagsSearch(obj))
    },
    tagsAllSearch: (obj) => {
      dispatch(tagsAllSearch(obj))
    }
  }
}

const TagsInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(TagsInfoView);

export default TagsInfo;



// WEBPACK FOOTER //
// ./src/containers/TagsInfo/TagsInfo.js